(() => {
  const selector = '[data-royaltyoak-giving]';
  let timer;
  let controller;
  let revision = 0;

  const refresh = async () => {
    const containers = Array.from(document.querySelectorAll(selector));
    if (!containers.length) return;
    controller?.abort();
    controller = new AbortController();
    const currentRevision = ++revision;
    try {
      const response = await fetch(containers[0].dataset.source, {
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
      });
      if (!response.ok) throw new Error('Giving message unavailable');
      const html = await response.text();
      if (currentRevision !== revision) return;
      const content = new DOMParser().parseFromString(html, 'text/html')
        .querySelector('[data-royaltyoak-giving-content]');
      if (!content) throw new Error('Giving message missing');
      containers.forEach(container => {
        const wasOpen = container.querySelector('details')?.open;
        const replacement = content.cloneNode(true);
        const disclosure = replacement.querySelector('details');
        if (disclosure) disclosure.open = Boolean(wasOpen);
        container.replaceChildren(replacement);
      });
    } catch (error) {
      if (error.name !== 'AbortError' && currentRevision === revision) {
        containers.forEach(container => container.replaceChildren());
      }
    }
  };

  const schedule = () => {
    controller?.abort();
    revision += 1;
    document.querySelectorAll(`${selector} [data-royaltyoak-giving-content]`)
      .forEach(content => { content.hidden = true; });
    clearTimeout(timer);
    timer = setTimeout(refresh, 80);
  };

  const initialize = () => {
    if (!document.querySelector(selector)) return;
    document.querySelectorAll('[data-products]').forEach(products => {
      new MutationObserver(schedule).observe(products, {childList: true, subtree: true});
    });
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:build', schedule);
    document.addEventListener('cart:open', schedule);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
})();
